import {useState, useEffect} from "react";

const useNitroViewport = () => {

  const determineCurrentOrientation = () => {
    return ((window.innerWidth > window.innerHeight) ?'landscape': 'portrait')
  }

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [orientation, setOrientation] = useState(determineCurrentOrientation());

  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      setOrientation(determineCurrentOrientation());
    }
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return { width, height, orientation };
}

export default useNitroViewport;
